import Redactor from '../../redactor.esm.min.js'
import { registerToolbarButton } from '../registerButton'

class MpMergeTagsPlugin {
    static defaultOptions = {
        input: true
    }

    static defaultLang = {
        en: {
            mpMergeTags: {
                title: 'Merge Tags'
            }
        }
    }

    constructor(app, options = {}) {
        this.app = app
        this.options = options
    }

    start() {
        registerToolbarButton(this.app, 'mpMergeTags', this._createToolbarButton())
    }

    _createToolbarButton() {
        return {
            title: this.app.getLang('mpMergeTags.title'),
            color: true,
            html: `<div>Merge Tags</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path d="M4.5 6L8.5 10L12.5 6" stroke="#9B9FA6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            `,
            classname: 'mp-redactor-toolbar-plugin mp-merge-tags-button',
            position: { before: 'moreinline' },
            command: 'mpMergeTags.popup'
        }
    }

    popup(_params, { button, el } = {}) {
        // Empty editor paragraphs are <p><br></p>. Insert needs a text node
        // as the caret target; this marker is stripped on save.
        this._prepareEmptyParagraphSelection()
        this.app.saveSelection()
        this.app.dropdown.create('mpMergeTags', { items: [] })
        this.app.dropdown.open(button || el)

        if (this.app.dropdown.getName() !== 'mpMergeTags') return

        const generateMergeTags = this.options.generateMergeTags
        if (typeof generateMergeTags === 'function') {
            generateMergeTags('mpMergeTags')
        }
    }

    _prepareEmptyParagraphSelection() {
        const win = this.app.host.getWindow()
        const selection = win.getSelection()
        if (!selection || !selection.rangeCount || !selection.isCollapsed) return

        const range = selection.getRangeAt(0)
        const element = range.startContainer.nodeType === 1 ? range.startContainer : range.startContainer.parentElement
        const paragraph = element && element.closest ? element.closest('p') : null
        const editor = this.app.host.getEditor()

        if (!paragraph || !editor || !editor.contains(paragraph) || !this._isBrOnlyParagraph(paragraph)) return

        const markerNode = editor.ownerDocument.createTextNode('\uFEFF')
        const br = Array.from(paragraph.childNodes).find((node) => node.nodeType === 1 && node.tagName === 'BR')
        paragraph.insertBefore(markerNode, br || null)

        range.setStart(markerNode, markerNode.nodeValue.length)
        range.collapse(true)
        selection.removeAllRanges()
        selection.addRange(range)
    }

    _isBrOnlyParagraph(paragraph) {
        const nodes = Array.from(paragraph.childNodes)
        return (
            nodes.length > 0 &&
            nodes.every((node) => {
                if (node.nodeType === 3) return node.nodeValue.replace(/\uFEFF/g, '').trim() === ''
                return node.nodeType === 1 && node.tagName === 'BR'
            })
        )
    }
}

Redactor.addPlugin('mpMergeTags', MpMergeTagsPlugin)
